import React from "react";
import "./Contact.css";
export default function Contact() {
  return (
    <div id="contact">
      <div className="contact">
        <div className="title-contact">
          <h3 className="text1-contact animate__animated animate__fadeInUp wow">
            Contact<span> me</span>
          </h3>
        </div>
        <div className="skill-content">
          <div className="main-contain">
            <h3 className="text3-contact animate__animated animate__fadeInUp wow">
              Get in <span>touch</span>
            </h3>
            <p className="para-contact animate__animated animate__fadeInUp wow">
              You can contact me for designing and developing UI/UX for you.
              Also i can teach you FSD(Full Stack Development). Feel free to
              message me 😊
            </p>
            <h3 className="text3-contact1 animate__animated animate__fadeInUp wow">📍 Address</h3>
            <p className="para-contact1 animate__animated animate__fadeInUp wow">
              Haridwar,Uttarakhand,INDIA
              <p>249401</p>
            </p>
            <h3 className="text3-contact1 animate__animated animate__fadeInUp wow">📧 Email</h3>
            <p className="para-contact1 animate__animated animate__fadeInUp wow">chauhanarjun064@gmail.com</p>
          </div>
          <form className="main-contain padd" >
            <div className="flex">
              <div class="inputBox animate__animated animate__fadeInUp wow">
                <input type="text" required="required" />
                <span>Full Name</span>
              </div>
              <div class="inputBox animate__animated animate__fadeInUp wow">
                <input type="text" required="required" />
                <span>email</span>
              </div>
              <div class="inputBox animate__animated animate__fadeInUp wow">
                <textarea type="text" required="required" />
                <span>message</span>
              </div>
            </div>
            <div>
              <a
                className="btn1-contact animate__animated animate__fadeInUp wow"
                href="mailto:chauhanarjun064@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <span>Send Message</span>
                <i></i>
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
